import { render, staticRenderFns } from "./AccountCertificationCardCollection.vue?vue&type=template&id=279a47ec&"
import script from "./AccountCertificationCardCollection.vue?vue&type=script&lang=js&"
export * from "./AccountCertificationCardCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports